import React, { useRef, useEffect, useState } from "react";
import {
  Chart,
  Series,
  ArgumentAxis,
  ValueAxis,
  Legend,
  Tooltip,
  CommonSeriesSettings,
  Label,
} from "devextreme-react/chart";
import ChartCard from "components/common/pyramid/ChartCard";

const WaterfallEffects = ({ data, palette }) => {
  const chartRef = useRef(null);
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const chartData = data.map((item, index) => {
      return {
        ...item,
        Line: item.Effect,
        Effect: item.Line,
      };
    });
    setChartData(chartData);
  }, [data]);

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  const customizeTooltip = (arg) => {
    if (arg.seriesName !== "Effect") {
      return { text: undefined };
    }
    return {
      text:
        "Effect : " +
        arg.argumentText +
        "<br/> ECL : " +
        formatter.format(Number(arg.rangeValue2) - Number(arg.rangeValue1)),
    };
  };

  const customizePoint = (arg) => {
    if (arg.seriesName === "Line") return;

    if (arg.data["Departure"] - arg.data["Arrival"] < 0) {
      return {
        color: palette[0],
        hoverStyle: { color: palette[0] },
      };
    } else if (arg.data["Departure"] - arg.data["Arrival"] >= 0) {
      return {
        color: palette[1],
        hoverStyle: { color: palette[1] },
      };
    }
  };

  return (
    <ChartCard
      title="Waterfall Effects"
      chartRef={chartRef}
      showLabelsOnExport={false}
      palette={palette}
    >
      <div className="p-4">
        <Chart
          dataSource={chartData}
          id="waterfallChart"
          ref={chartRef}
          customizePoint={customizePoint}
          barGroupPadding={0.4}
        >
          <CommonSeriesSettings argumentField="Effect" type="rangebar" />

          <Series
            type="stepline"
            argumentField="Effect"
            valueField="Arrival"
            color="#000"
            dashStyle="solid"
            width={1}
            point={{
              visible: false,
            }}
            hoverMode="none"
          />

          <Series
            rangeValue1Field="Departure"
            rangeValue2Field="Arrival"
            name="Effect"
            hoverMode="nearestPoint"
          />

          <ArgumentAxis>
            <Label overlappingBehavior="rotate" rotationAngle={45} />
          </ArgumentAxis>

          <ValueAxis inverted={false} grid={{ visible: true }} position="left">
            <Label
              customizeText={(arg) => {
                return formatter.format(Math.abs(arg.value));
              }}
            />
          </ValueAxis>

          <Legend visible={false} />

          <Tooltip
            enabled={true}
            customizeTooltip={customizeTooltip}
            html={true}
          />
        </Chart>
      </div>
    </ChartCard>
  );
};

export default WaterfallEffects;
